export class TwoFactorRequest {
    userName: string;
    code: string;
    rememberMe: boolean;
}
